var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStyloetblocnote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e6007e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bloc_notes_stylo",
    "data-name": "bloc notes stylo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.47,31a.76.76,0,0,0,.76-.77V19.13a2.31,2.31,0,0,0-2.3-2.31H38.09v-.61a2.46,2.46,0,1,0-4.91,0v.61H31.49v-.61a2.46,2.46,0,1,0-4.91,0v.61H24.89v-.61a2.46,2.46,0,0,0-4.92,0v.61H18.13a2.31,2.31,0,0,0-2.3,2.31v26.1a.74.74,0,0,0,.23.54l7.05,7.06a.77.77,0,0,0,.54.22H39.93a2.3,2.3,0,0,0,2.3-2.3V49.29a.77.77,0,1,0-1.53,0v1.46a.78.78,0,0,1-.77.77H24.42V46.76a2.3,2.3,0,0,0-2.3-2.3H17.37V24.35H40.7V30.2A.76.76,0,0,0,41.47,31ZM22.12,46a.77.77,0,0,1,.77.76v3.67L18.45,46ZM34.71,16.21a.92.92,0,1,1,1.84,0v.61H34.71v-.61Zm-6.6,0a.92.92,0,0,1,1.84,0v.61H28.11Zm-6.6,0a.92.92,0,0,1,1.84,0v.61H21.51Zm-4.14,6.6V19.13a.76.76,0,0,1,.76-.77h5.22V19a.92.92,0,0,1-.92.92.77.77,0,0,0,0,1.54A2.46,2.46,0,0,0,24.89,19v-.61H30V19a.92.92,0,0,1-.92.92.77.77,0,0,0,0,1.54A2.46,2.46,0,0,0,31.49,19v-.61h5.06V19a.92.92,0,0,1-.92.92.77.77,0,1,0,0,1.54A2.46,2.46,0,0,0,38.09,19v-.61h1.84a.77.77,0,0,1,.77.77v3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42,32.87a.77.77,0,0,0-.54-.22.8.8,0,0,0-.55.22.77.77,0,0,0-.22.54.82.82,0,0,0,.22.55.8.8,0,0,0,.55.22A.77.77,0,0,0,42,34a.82.82,0,0,0,.22-.55A.77.77,0,0,0,42,32.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.57,31.41H21.5a.77.77,0,1,0,0,1.53H36.57a.77.77,0,0,0,0-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.57,35.71H21.5a.77.77,0,1,0,0,1.53H36.57a.77.77,0,0,0,0-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.57,40H21.5a.77.77,0,1,0,0,1.54H36.57a.77.77,0,0,0,0-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.57,27.11H24.86a.77.77,0,1,0,0,1.53H36.57a.77.77,0,0,0,0-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22,27.33a.77.77,0,0,0-.54-.22.75.75,0,0,0-.77.77.77.77,0,0,0,.22.54.8.8,0,0,0,.55.22.75.75,0,0,0,.76-.76A.8.8,0,0,0,22,27.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.51,23.76a3.2,3.2,0,0,0-4.4,1.18L39.45,41.67a1,1,0,0,0-.1.29l-.68,6.09a.77.77,0,0,0,.38.75.79.79,0,0,0,.39.11.74.74,0,0,0,.45-.15l4.94-3.64a.93.93,0,0,0,.21-.23l9.65-16.73A3.22,3.22,0,0,0,53.51,23.76ZM40.39,46.48l.36-3.18L43,44.58Zm3.7-3-2.92-1.69,7.75-13.43L51.84,30Zm9.28-16.07-.76,1.31L49.68,27l.76-1.31a1.7,1.7,0,0,1,2.31-.61,1.64,1.64,0,0,1,.78,1A1.68,1.68,0,0,1,53.37,27.39Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyloetblocnote);
export default __webpack_public_path__ + "static/media/styloetblocnote.e871132dc3a7b87ccd1a47deb7fa0ff6.svg";
export { ForwardRef as ReactComponent };